import { ItemListContainer, ItemWrapper, ItemInfoWrapper, ItemTitleWrapper, ColumnWrapper, ItemLeftWrapper, ItemActionsWrapper, ContentColapsibleWrapper } from "./itemList.styled";
import { Typography, Icon, Button } from "@ann/web-components";
import { useState } from "react";




const CallItem = ({ info }) => {

    const [showCallInfo, setShowCallInfo] = useState(false);

    // Add safety check for info prop
    if (!info) {
        return null;
    }

    return (
        <ItemListContainer>
            <ItemWrapper>
                <ItemLeftWrapper>
                    <ItemTitleWrapper>
                        <Icon name='call' size='small' />
                        <Typography category='subtitle' weight='bold' size='medium'>Follow-up</Typography>
                    </ItemTitleWrapper>
                    <ItemInfoWrapper>
                        <ColumnWrapper>
                            <Typography category='subtitle' weight='bold' size='small'>
                                Agent
                            </Typography>
                            <Typography category='body' weight='regular' size='small' color='body'>
                                {info.agent || 'N/A'}
                            </Typography>
                        </ColumnWrapper>
                        <ColumnWrapper>
                            <Typography category='subtitle' weight='bold' size='small'>
                                Duration
                            </Typography>
                            <Typography category='body' weight='regular' size='small'>
                                {info.duration || 'N/A'}
                            </Typography>
                        </ColumnWrapper>
                        <ColumnWrapper>
                            <Typography category='subtitle' weight='bold' size='small'>
                                Call Type
                            </Typography>
                            <Typography category='body' weight='regular' size='small' color='body'>
                                {info.callType || 'N/A'}
                            </Typography>
                        </ColumnWrapper>
                        <ColumnWrapper>
                            <Typography category='subtitle' weight='bold' size='small'>
                                Disposition
                            </Typography>
                            <Typography category='body' weight='regular' size='small' color='body'>
                                {info.disposition || 'N/A'}
                            </Typography>
                        </ColumnWrapper>
                        <ColumnWrapper>
                            <Typography category='subtitle' weight='bold' size='small'>
                                Outcome
                            </Typography>
                            <Typography category='body' weight='regular' size='small' color='body'>
                                {info.outCome || 'N/A'}
                            </Typography>
                        </ColumnWrapper>
                        <ColumnWrapper>
                            <Typography category='subtitle' weight='bold' size='small'>
                                Timestamp
                            </Typography>
                            <Typography category='body' weight='regular' size='small' color='body'>
                                {info.timestamp || 'N/A'}
                            </Typography>
                        </ColumnWrapper>
                    </ItemInfoWrapper>
                </ItemLeftWrapper>
                <ItemActionsWrapper>
                    <Button size='small' type='secondary' icon={showCallInfo ? 'chevronUp' : 'chevronDown'} pill={true} onClick={() => setShowCallInfo(!showCallInfo)} />
                </ItemActionsWrapper>
            </ItemWrapper>
            {showCallInfo && (
                <ContentColapsibleWrapper>
                    <Icon name='aiChat' size='medium' color='success' />
                    <Typography category='body' weight='regular' size='small' color='body'>
                        {info.callInfo || 'No call information available'}
                    </Typography>
                </ContentColapsibleWrapper>
            )}
        </ItemListContainer>
    )
}

export default CallItem;